export default __webpack_public_path__ + "static/media/delete.d31eaff1.jpg";